import * as React from 'react';
import { styles } from './styles';

export type Props = {
  handleMonthClick: (delta: number) => any;
  handleTodayClick: () => any;
};

const MonthToggler: React.SFC<Props> = ({ handleMonthClick, handleTodayClick }) => {
  return (
    <div className={styles.headerActionRules}>
      <div className={styles.chevronContainerRules} onClick={handleMonthClick(-1)}>
        <div className={styles.chevronRules('left')} />
      </div>
      <div className={styles.todayRules} onClick={handleTodayClick}>
        Today
      </div>
      <div className={styles.chevronContainerRules} onClick={handleMonthClick(1)}>
        <div className={styles.chevronRules('right')} />
      </div>
    </div>
  );
};

export { MonthToggler };
